import { Box, Button, CircularProgress, Typography } from "@mui/material"
import SelfEvaluationList from "./List/EvaluationSelfList";
import { useNavigate } from "react-router-dom";
import { useBasePath } from "components/Providers";
import NoRecords from "components/NoRecords";
import { LightbulbTwoTone } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const EvaluationSelf = ({ selfEvaluationList }) => {
    const navigate = useNavigate();
    const basUrl = useBasePath();
    const loading = useSelector(state => state.adminEvaluation.selfEvaluation.loading);
    const { t } = useTranslation()

    const boxStyles = {
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 2.5,
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        maxHeight: "400px",
        overflowY: "auto",
        overflowX: "auto",
      };

    const innerBoxStyles = {
        mt: 2,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
    };

    return (
        <Box sx={{ ...boxStyles, flexGrow: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">{t('Self-Evaluation')}</Typography>
                <Button variant="contained" color="primary" size="small" onClick={() => navigate(`${basUrl}/self/add`)}>
                    {t('Add/Update Evaluation')}
                </Button>
            </Box>
            {loading ? (
                <Box sx={{ ...innerBoxStyles }}>
                    <CircularProgress size={50} />
                </Box>
            ) : selfEvaluationList?.length > 0 ? (
            <Box sx={{ ...innerBoxStyles, alignItems: "flex-start" }}>
                <SelfEvaluationList selfEvaluationList={selfEvaluationList} />
            </Box>
            ) : (
                <Box sx={{ ...innerBoxStyles }}>
                    <NoRecords
                        icon={<LightbulbTwoTone sx={{ fontSize: 50, color: "primary.main" }} />}
                        message="No Self-Evaluation Yet"
                    />
                </Box>
            )}
        </Box>
    )
}

export default EvaluationSelf